(() => {
  const connected = new WeakSet();
  const initialize = (root) => {
    if (connected.has(root)) return;
    const select = root.querySelector('[data-hf-contact-subject]');
    const native = root.querySelector('[data-hf-contact-native]');
    const form = root.querySelector('form');
    const help = root.querySelector('[data-hf-contact-help]');
    if (!select || !native || !form) return;
    const prefix = root.closest('.shopify-section').id.split('__').slice(0, -1).join('__');
    const findSection = (key) => key ? document.getElementById(prefix + '__' + key) : null;
    const panels = {
      care: findSection(root.dataset.careSection),
      returns: findSection(root.dataset.returnsSection)
    };
    let nativeFallback = false;
    const refresh = () => {
      const route = select.selectedOptions[0]?.dataset.photoRoute || '';
      const panel = panels[route];
      const usePhoto = Boolean(panel) && !nativeFallback;
      native.hidden = usePhoto;
      native.disabled = usePhoto;
      help.hidden = !usePhoto;
      root.closest('.shopify-section').classList.toggle('hf-contact-has-photo', usePhoto);
      Object.values(panels).filter(Boolean).forEach((item) => {
        const active = usePhoto && item === panel;
        item.hidden = !active;
        item.inert = !active;
        item.setAttribute('data-hf-contact-photo-visible', String(active));
      });
      select.setAttribute('aria-expanded', String(usePhoto));
      if (usePhoto) select.setAttribute('aria-controls', panel.id);
      else select.removeAttribute('aria-controls');
    };
    select.addEventListener('change', () => {
      nativeFallback = false;
      refresh();
    });
    form.addEventListener('submit', (event) => {
      if (native.disabled) event.preventDefault();
    });
    root.querySelector('[data-hf-contact-fallback]')?.addEventListener('click', () => {
      nativeFallback = true;
      refresh();
      select.focus();
    });
    connected.add(root);
    refresh();
  };
  const scan = () => document.querySelectorAll('[data-hf-contact-router]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
